<template>
	<div class="ds-page-header">
		<div v-if="$slots.leading" class="ds-page-header__leading">
			<slot name="leading" />
		</div>
		<div class="ds-page-header__main">
			<nav v-if="breadcrumb" class="ds-page-header__breadcrumb">{{ breadcrumb }}</nav>
			<div class="ds-page-header__title-row">
				<slot name="title-prefix" />
				<h1 class="ds-page-header__title">{{ title }}</h1>
			</div>
		</div>
		<div v-if="$slots.actions" class="ds-page-header__actions">
			<slot name="actions" />
		</div>
	</div>
</template>

<script>
export default {
	name: "OvPageHeader",
	props: {
		title: { type: String, required: true },
		breadcrumb: { type: String, default: "" },
	},
};
</script>
